var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("Field", {
            attrs: {
              label: _vm.$t("BUYER_DUPLICATE_RESTRICTION"),
              "has-tooltip": true,
              "tooltip-text": _vm.$t("BUYER_DUPLICATE_RESTRICTION_TT")
            },
            scopedSlots: _vm._u([
              {
                key: "element",
                fn: function() {
                  return [
                    _c("ValidationProvider", {
                      ref: "settingsCopy.trackBy",
                      attrs: { rules: "", slim: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function({ classes }) {
                            return [
                              _c("div", { class: classes }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-xs-4 col-lg-3 r-form__input"
                                  },
                                  [
                                    _c("v-select", {
                                      staticClass: "m-t-0 p-t-1",
                                      attrs: {
                                        clearable: false,
                                        searchable: false,
                                        options: _vm.restrictionTypes,
                                        label: "name",
                                        reduce: _vm.reduceValues(),
                                        disabled:
                                          _vm.settingsCopy.trackBy ===
                                          "not supported"
                                      },
                                      model: {
                                        value: _vm.settingsCopy.trackBy,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.settingsCopy,
                                            "trackBy",
                                            $$v
                                          )
                                        },
                                        expression: "settingsCopy.trackBy"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    })
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.showSettings
        ? [
            _c("Field", {
              attrs: {
                label: _vm.$t("BUYER_DUPLICATE_RESTRICTION_CONDITION"),
                "has-tooltip": true,
                "tooltip-text": _vm.$t(
                  "BUYER_DUPLICATE_RESTRICTION_CONDITION_TT"
                )
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "element",
                    fn: function() {
                      return [
                        _c("ValidationProvider", {
                          ref: "settingsCopy.previousCallState",
                          attrs: { rules: "", slim: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ classes }) {
                                  return [
                                    _c("div", { class: classes }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-xs-4 col-lg-3 r-form__input"
                                        },
                                        [
                                          _c("v-select", {
                                            staticClass: "m-t-0 p-t-1",
                                            attrs: {
                                              options: _vm.restrictionCallTypes,
                                              clearable: false,
                                              searchable: false,
                                              label: "name",
                                              reduce: _vm.reduceValues()
                                            },
                                            model: {
                                              value:
                                                _vm.settingsCopy
                                                  .previousCallState,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.settingsCopy,
                                                  "previousCallState",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "settingsCopy.previousCallState"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2644640167
                          )
                        })
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                3340304449
              )
            }),
            _vm._v(" "),
            _c("Field", {
              attrs: {
                label: _vm.$t("BUYER_DUPLICATE_RESTRICTION_DURATION"),
                "has-tooltip": true,
                "tooltip-text": _vm.$t(
                  "BUYER_DUPLICATE_RESTRICTION_DURATION_TT"
                )
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "element",
                    fn: function() {
                      return [
                        _c("ValidationProvider", {
                          ref: "settingsCopy.allowDuplicatesAfter",
                          attrs: { rules: "required", slim: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ classes }) {
                                  return [
                                    _c("div", { class: classes }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-xs-4 col-lg-3 r-form__input btn-group toggle-wrap"
                                        },
                                        [
                                          _c(
                                            "btn-group",
                                            [
                                              _c(
                                                "btn",
                                                {
                                                  attrs: {
                                                    "input-type": "radio",
                                                    "input-value":
                                                      _vm.blockDurationValues
                                                        .always,
                                                    type: "primary"
                                                  },
                                                  model: {
                                                    value: _vm.blockDuration,
                                                    callback: function($$v) {
                                                      _vm.blockDuration = $$v
                                                    },
                                                    expression: "blockDuration"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(_vm.$t("ALWAYS")) +
                                                      "\n                "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "btn",
                                                {
                                                  attrs: {
                                                    "input-type": "radio",
                                                    "input-value":
                                                      _vm.blockDurationValues
                                                        .time,
                                                    type: "primary"
                                                  },
                                                  model: {
                                                    value: _vm.blockDuration,
                                                    callback: function($$v) {
                                                      _vm.blockDuration = $$v
                                                    },
                                                    expression: "blockDuration"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "BUYER_DUPLICATE_RESTRICTION_DURATION_TIME_LIMIT"
                                                        )
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            4055609902
                          )
                        })
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                841445562
              )
            }),
            _vm._v(" "),
            _vm.blockDuration === "time"
              ? _c("Field", {
                  attrs: { label: " ", "has-tooltip": false },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "element",
                        fn: function() {
                          return [
                            _c("ValidationProvider", {
                              ref: "settingsCopy.allowDuplicatesAfter",
                              attrs: {
                                rules: "required|min_value:1|max_value:365",
                                slim: ""
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ classes, errors }) {
                                      return [
                                        _c("div", { class: classes }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col-sm-4 col-md-9"
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.settingsCopy
                                                        .allowDuplicatesAfter,
                                                    expression:
                                                      "settingsCopy.allowDuplicatesAfter"
                                                  }
                                                ],
                                                staticClass:
                                                  "form-control width-80",
                                                attrs: { type: "number" },
                                                domProps: {
                                                  value:
                                                    _vm.settingsCopy
                                                      .allowDuplicatesAfter
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      _vm.settingsCopy,
                                                      "allowDuplicatesAfter",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("span", [_vm._v("days")]),
                                              _vm._v(" "),
                                              errors && errors[0]
                                                ? _c("label", {
                                                    directives: [
                                                      {
                                                        name: "t",
                                                        rawName: "v-t",
                                                        value:
                                                          "BUYER_DUPLICATE_RESTRICTION_DURATION_INVALID",
                                                        expression:
                                                          "'BUYER_DUPLICATE_RESTRICTION_DURATION_INVALID'"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "form-group__label-required vv-invalid",
                                                    attrs: {
                                                      name:
                                                        "buyerRouteDuplicatesAllowDuplicatesAfter-invalid-label",
                                                      "data-cy":
                                                        "buyerRouteDuplicatesAllowDuplicatesAfter"
                                                    }
                                                  })
                                                : _c("label", {
                                                    directives: [
                                                      {
                                                        name: "t",
                                                        rawName: "v-t",
                                                        value: "REQUIRED",
                                                        expression: "'REQUIRED'"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "form-group__label-required m-l-10"
                                                  })
                                            ]
                                          )
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1963956378
                              )
                            })
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    1612062682
                  )
                })
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }